<template>
  <custom-modal :size="'max-w-3xl'">
    <template v-slot:maincontent>
        <div class="mt-4 p-4 text-[14px] bg-theme-modalbg rounded-lg">
          <div class="relative">
            <h2 class="text-3xl text-white text-center tracking-wider font-normal pr-[40px]">You Are About To {{ business.status ? 'Disable' : 'Enable'}} A Business</h2>
            <span class="absolute right-1 top-1 pointer cursor-pointer hover:opacity-60"  @click.prevent="callback()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3333 2.54602L17.4533 0.666016L10 8.11935L2.54667 0.666016L0.666672 2.54602L8.12001 9.99935L0.666672 17.4527L2.54667 19.3327L10 11.8793L17.4533 19.3327L19.3333 17.4527L11.88 9.99935L19.3333 2.54602Z" fill="white"/>
              </svg>
            </span>
          </div>
          
          <div class="m-2 mt-4 tracking-wider grid-cols-4 bg-theme-modal_inner_bg rounded py-2 px-2 pb-4">
            <div class="full justify-content-center">
              <p class="text-center text-white text-base mt-2 tracking-wider font-normal">We wouldn’t want you to do that by mistake!</p>
            </div>
            <div class="full flex">
              <button @click.prevent="toggleBusinessStatus()" class="uppercase text-white bg-theme-green hover:bg-theme-darkgreen w-3/5 mt-6  text-sm font-medium tracking-widest border-0 rounded-md p-2 block mx-auto">CONFIRM</button>
            </div>
          </div>
         
          <div class="mt-3 mb-1 text-center">
            <button @click.prevent="callback()" class="text-white hover:text-theme-green text-center text-sm font-medium tracking-widest">CANCEL</button>
          </div>
        </div>
        
    </template>
  </custom-modal>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/helpers';
import { useSnackbar } from "vue3-snackbar";
import BusinessApis from "@/controllers/BusinessApis";

export default defineComponent({
  name: "ToggleBusinessStatus",
  components: {
  },
  
  setup() {
    const snackbar = useSnackbar();
    return {
      snackbar,
    };
  },
  
  props: {
    business: {
      type: Object,
      required: true,
    },
    callback: {
      type: Function,
      required: true,
    },
  },

  methods: {
    /**
     * Toggle business status
     */
    async toggleBusinessStatus() {
      this.va_spinner(true);
      let res = await BusinessApis.updateBusiness(this.business.id, {
        status: !this.business.status,
      })
      if(res.status == 200) {
        // re fetch business and sync
        await this.va_setUserBusinesses();
        this.callback();
      }
      this.va_spinner(false);
      this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_setUserBusinesses: "auth/setUserBusinesses",
    })

  },
});
</script>